// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"35d6392e","186":"1dca24e6","225":"2fe1f731","344":"3e65d722","372":"86cb663e","738":"619b834b","841":"3e9c6e6c","856":"458084b0"}[chunkId] + ".chunk.js";
};